import React, { useEffect, useState } from 'react';
import { Wrapper, Content, MainMessage, IconWrapper } from './Error.styled';
import Title from '@components/molecules/Title/Title';
import Icon from '@components/atoms/Icon/Icon';

export const NOT_FOUND = 'notFound';
export const NO_PARAMS = 'noParams';
export const INTERNAL = 'internal';

const Error = ({ type }) => {
  const [title, setTitle] = useState('Erreur…');
  const [context, setContext] = useState('error');
  const [isVisible, setIsVisible] = useState(true);
  const [mainMessage, setMainMessage] = useState("Oups ! Il semble qu'une erreur soit survenue.");
  const [subMessage, setSubMessage] = useState("C'est notre faute, non la vôtre.");

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(false);
    }, 1000)

    switch (type) {
      case NOT_FOUND:
        setTitle("Formation inconnue");
        setMainMessage("Oups ! Il semble qu'une erreur humaine se soit glissée dans cette page.");
        setSubMessage("Les paramètres semblent mal utilisés.");
        setContext(type);
        break;
      case NO_PARAMS:
        setTitle("Formation manquante");
        setMainMessage("Oups ! Il semble qu'il soit impossible de charger le formulaire.");
        setSubMessage("Aucun paramètre n'est reçu.");
        setContext(type);
        break;
    }
  });

  return (
    <Wrapper data-testid={`test_error_${context}`}>
      <Title title={title} context={context} />
      <Content>
        <MainMessage>{mainMessage}</MainMessage>
        <IconWrapper>
          <Icon name="hat" out={isVisible} />
        </IconWrapper>
        <p>{subMessage}</p>
      </Content>
    </Wrapper>
  )
}

export default Error;
